(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Four-Col-Slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videoCovers = document.querySelectorAll('.video-cover');
    const closeButtons = document.querySelectorAll('.close-popup');
  
    videoCovers.forEach(cover => {
      cover.addEventListener('click', function() {
        const videoId = this.dataset.videoId;
        const popup = document.getElementById(`video-popup-${videoId}`);
        if (popup) {
          popup.classList.add('open');
        }
      });
    });
  
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const popup = this.closest('.video-popup');
        if (popup) {
          popup.classList.remove('open');
          // Optional: Pause the video when closing
          const video = popup.querySelector('.popup-video');
          if (video) {
            video.pause();
          }
        }
      });
    });
  
    const reviewSlider = document.querySelector('.review-slider');
    if (reviewSlider) {
      new Flickity(reviewSlider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        groupCells: 4,
        pageDots: true,
        prevNextButtons: true
      });
    }
  });

    window.addEventListener('load', function () {
    const slider = document.querySelector('.review-slider');
    if (!slider) return;

    // Wait for all images inside the slider to load
    const images = slider.querySelectorAll('img');
    let loaded = 0;

    images.forEach(img => {
      if (img.complete) {
        loaded++;
      } else {
        img.addEventListener('load', () => {
          loaded++;
          if (loaded === images.length) {
            initializeFlickity();
          }
        });
        img.addEventListener('error', () => loaded++);
      }
    });

    if (loaded === images.length) {
      initializeFlickity();
    }

    function initializeFlickity() {
      const flkty = new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        groupCells: 1,
        pageDots: true,
        prevNextButtons: true,
        imagesLoaded: true
      });

      // Force height recalc
      flkty.resize();
    }
  });




  } catch(e) { console.error(e); }
})();
})();
